<template>
  <div class="news-item">
    <div class="item-header">
      <div class="item-img-des">
        <img :src="dataList.focusPic" alt="" />
        <span v-if="dataList.stage == 0" class="stage-jxz">进行中</span>
        <span v-if="dataList.stage == 1" class="stage-zmz">招募中</span>
        <span v-if="dataList.stage == 2" class="stage-yjs">已结束</span>
      </div>
      <div class="item-content">
        <p>
          <a :href="'/detail/' + dataList.id + '/1'" target="_blank">{{
            dataList.title
          }}</a>
        </p>
        <p v-if="myList">
          <span class="active-term">活动时间：</span
          ><span>{{ dataList.beginTime }} 至 {{ dataList.endTime }}</span>
        </p>
        <p>
          <span class="active-term">报名截止时间：</span
          ><span>{{ dataList.closeTime }}</span>
        </p>
        <p v-if="myList && joinType == 0">
          <span class="active-term">参加人数：</span
          ><span>{{ dataList.peopleNum }}</span>
        </p>
        <p v-if="myList && joinType == 1">
          <span class="active-term">审核状态：</span>
          <span class="status-dsh" v-if="dataList.status == 0">待审核</span>
          <span class="status-ytg" v-if="dataList.status == 1">已通过</span>
          <span class="status-bjj" v-if="dataList.status == 2">被拒绝</span>
        </p>
        <p v-else>
          <span class="active-term">活动地点：</span
          ><span>{{ dataList.address }}</span>
        </p>
      </div>
    </div>
    <div class="item-footer">
      <div class="pub-user-info">
        <div class="user-name" @click="userCenter(dataList.userId)">
          <img
            :src="
              dataList.userIcon
                ? dataList.userIcon
                : '/static/img/mr-usericon.png'
            "
            alt=""
          />
          {{ dataList.userName }}
        </div>
        <span class="ml20"
          ><i class="el-icon-time"></i>{{ dataList.formatPublicTime }}</span
        >
        <span class="ml20"><i class="el-icon-view"></i>{{ dataList.pvStr }}</span>
        <span class="ml20"
          ><i class="el-icon-chat-square"></i>{{ dataList.discussNum }}</span
        >
      </div>
      <el-button
        round
        v-if="myList && joinType == 0"
        class="look-sign-up-list"
        @click="getData(dataList.id)"
        >查看报名人员<i class="el-icon-arrow-right"></i
      ></el-button>
    </div>
    <el-dialog
      title="已报名人员名单"
      :visible.sync="dialogTableVisible"
      header-cell-style="{background: '#F9F9F9'}"
    >
      <ul class="tab-bar cl">
        <li @click="tabClick(0)" :class="{ active: status == 0 }">未审核</li>
        <li @click="tabClick(1)" :class="{ active: status == 1 }">已通过</li>
        <li @click="tabClick(2)" :class="{ active: status == 2 }">已拒绝</li>
      </ul>
      <el-table :data="gridData">
        <el-table-column
          property="id"
          label="序号"
          width="80"
        ></el-table-column>
        <el-table-column
          property="name"
          label="姓名"
          width="150"
        ></el-table-column>
        <el-table-column property="phone" label="手机号"></el-table-column>
        <el-table-column
          property="createTime"
          label="报名时间"
        ></el-table-column>
        <el-table-column v-if="status == 0" label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="activityEnrollCheck(scope.row.id, '1')"
              class="tg-btn"
              >通过</el-button
            >
            <el-button
              size="mini"
              @click="activityEnrollCheck(scope.row.id, '2')"
              class="jj-btn"
              >拒绝</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "hotPost",
  props: ["dataList", "myList", "joinType"],
  data() {
    return {
      addTypeFlag: false,
      dialogTableVisible: false,
      current: 1,
      size: 10,
      gridData: [],
      activityId: "",
      total: 0,
      status: 0,
    };
  },
  methods: {
    tabClick(num) {
      this.status = num;
      this.page = 1;
      this.gridData = [];
      this.getData(this.activityId);
    },
    handleSizeChange(e) {
      this.size = e;
      this.getData(this.activityId);
    },
    handleCurrentChange(e) {
      this.current = e;
      this.getData(this.activityId);
    },
    getData(id) {
      this.dialogTableVisible = true;
      this.activityId = id;
      this.$api
        .activityEnrollList({
          activityId: id,
          current: this.current,
          size: this.size,
          status: this.status,
        })
        .then((res) => {
          this.total = res.data.data.total;
          this.gridData = res.data.data.records;
        });
    },
    activityEnrollCheck(id, status) {
      this.$api
        .activityEnrollCheck({
          activityUserId: id,
          status: status,
        })
        .then((res) => {
          this.$message.success("成功");
          this.getData(this.activityId);
        });
    },
    userCenter(id) {
      this.$router.push("/usercenter/" + id);
    },
  },
};
</script>

<style scoped lang="scss">
.news-item {
  padding: 24px 24px 20px;
  border-bottom: 1px solid #efefef;
  .item-header {
    width: 100%;
    display: flex;
    .item-content {
      width: calc(100% - 190px);
      font-size: 18px;
      line-height: 25px;
      height: 27px;
      padding-left: 10px;
      p {
        width: 100%;
        font-size: 14px;
        margin-top: 2px;
        display: flex;
        a {
          color: #121212;
          display: block;
          font-size: 18px;
          font-weight: 600;
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        span {
          color: #121212;
        }
        .active-term {
          width: 120px;
          color: #999999;
        }
        .status-bjj {
          color: #317DFF;
        }
      }
      .bm-btn {
        width: 100%;
        margin-top: 10px;
        display: flex;
        .wybm {
          width: 92px;
          height: 32px;
          background: #317DFF;
          border-radius: 16px;
          padding: 0;
          font-size: 15px;
          font-weight: 400;
          color: #ffffff;
        }
        .ybm {
          width: 76px;
          height: 32px;
          background: #ebebeb;
          border-radius: 16px;
          padding: 0;
          font-size: 15px;
          font-weight: 400;
          color: #4c4c4c;
        }
      }
    }
    .item-img-des {
      position: relative;
      display: flex;
      span {
        position: absolute;
        border-radius: 3px;
        font-size: 12px;
        font-weight: 400;
        padding: 2px 3px;
        right: 5px;
        bottom: 5px;
      }
      .stage-jxz {
        background: #e5effe;
        color: #317DFF;
      }
      .stage-zmz {
        background: #dcf3c9;
        color: #018439;
      }
      .stage-yjs {
        background: #ebebeb;
        color: #4c4c4c;
      }
      img {
        width: 190px;
        height: 116px;
        border-radius: 4px;
      }
      p {
        width: auto;
        padding-left: 10px;
        text-align: justify;
      }
    }
  }

  .item-footer {
    margin-top: 17px;
    color: #999999;
    font-size: 13px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    .pub-user-info {
      height: 34px;
      line-height: 34px;
      span {
        font-size: 13px;
      }
      .user-name {
        cursor: pointer;
        float: left;
        font-size: 13px;
      }
      img {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        vertical-align: middle;
        margin-right: 10px;
      }
      i {
        font-size: 20px;
        vertical-align: middle;
        margin-right: 8px;
      }
    }
    .look-sign-up-list {
      width: 136px;
      height: 34px;
      padding: 0;
      text-align: center;
      line-height: 34px;
      background: #e5effe;
      border-radius: 17px;
      font-size: 16px;
      font-weight: 400;
      color: #317DFF;
    }
  }
  /deep/ .el-dialog {
    .el-dialog__body {
      padding-top: 0;
      .tab-bar {
        line-height: 2.5;
        padding: 0 24px;
        border-bottom: 1px solid #efefef;
        margin-bottom: 8px;
        li {
          float: left;
          margin-right: 50px;
          font-size: 16px;
          cursor: pointer;
          color: #121212;
          &.active {
            font-weight: 600;
            border-bottom: 4px solid #317DFF;
            border-radius: 2px;
          }
        }
      }
      .el-table th {
        background: #f9f9f9;
      }
      .el-table th > .cell {
        font-size: 14px;
        color: #666666;
        font-weight: 400;
      }
      .el-table .cell {
        font-size: 14px;
        color: #121212;
        font-weight: 400;
      }
      .tg-btn {
        border: none;
        background: #dcf3c9;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color: #018439;
      }
      .jj-btn {
        border: none;
        background: #e5effe;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color: #317DFF;
      }
      .el-pagination {
        margin-top: 10px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ActivityList.vue